/*
 * Copyright (c) 2021-2024. World Wide Generation Ltd
 */

import Header from '@features/header';
import { Route, Switch } from 'react-router-dom';
import { RouteErrorBoundary } from '@features/error';
import { AppLayout } from '../../layout/AppLayout';
import { emissionsCalculatorsRoutes } from './routes';
import { getHydratedRoutes } from '../../constants/routeComponents';
import { HydratedRouteInterface } from '../../types/routes';
import { NotFound } from '@routes/not-found/NotFound';

const routes = getHydratedRoutes(emissionsCalculatorsRoutes);

/**
 * Emissions Calculator App entry point
 */
const component = (props: any) => <Header {...props} />;

export const EmissionsCalculatorsRoute = () => {


  return (
    <RouteErrorBoundary>
      <AppLayout Header={<Route path={routes.EMISSIONS_CALCULATORS.path} component={component} />}>
        <Switch>
          <Route {...routes.SIMPLE_CARBON_CALCULATOR} />
          <Route {...routes.EMISSIONS_CALCULATORS} />
          <Route {...routes.EMISSIONS_PARTNER} />
          <Route>
            <NotFound />
          </Route>
        </Switch>
      </AppLayout>
    </RouteErrorBoundary>
  );
}

export const emissionsCalculatorsRouteEntry: HydratedRouteInterface = {
  id: 'emissions_calculators_entry',
  label: 'Emissions Calculator',
  path: '/emissions-calculator',
  exact: false,
  component: EmissionsCalculatorsRoute
}
